import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { FiPower, FiTrash2, FiPlus } from 'react-icons/fi';
import './AdminPanel.css';
import Navbar from './Navbar';

const WhitelistIPPage = () => {
    const [whitelistEnabled, setWhitelistEnabled] = useState(true);
    const [ipAddress, setIpAddress] = useState('');
    const [whitelistedIPs, setWhitelistedIPs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [authChecked, setAuthChecked] = useState(false);
    const [isAdding, setIsAdding] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const navigate = useNavigate();

    const getCookie = (name) => {
        const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
        return match ? decodeURIComponent(match[1]) : null;
    };

    const checkAuth = async () => {
        try {
            const token = getCookie('offerAdminAuth');
            if (!token) {
                navigate('/adminBT/login');
                return false;
            }

            const res = await axios.post('https://offers.cashbolt.in.net/server/', {
                action: 'checkAuth',
                authToken: token
            });

            if (!res.data.status) {
                navigate('/adminBT/login');
                return false;
            }
            return true;
        } catch (error) {
            navigate('/adminBT/login');
            return false;
        }
    };

    const fetchWhitelistSettings = async () => {
        try {
            const token = getCookie('offerAdminAuth');
            const response = await axios.post('https://offers.cashbolt.in.net/server/', {
                action: 'getIPWhitelistSettings',
                authToken: token
            });

            if (response.data.status) {
                setWhitelistEnabled(response.data.data.whitelistEnabled);
                setWhitelistedIPs(response.data.data.whitelistedIPs || []);
            } else {
                console.error('Failed to fetch IP whitelist settings:', response.data.message);
            }
        } catch (error) {
            console.error("Error fetching IP whitelist settings:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const verifyAuth = async () => {
            const isAuthenticated = await checkAuth();
            setAuthChecked(isAuthenticated);
            if (isAuthenticated) {
                await fetchWhitelistSettings();
            }
        };
        verifyAuth();
    }, []);

    const handleAddIP = async () => {
        if (!ipAddress || !isValidIP(ipAddress)) {
            alert('Please enter a valid IP address');
            return;
        }

        setIsAdding(true);
        try {
            const token = getCookie('offerAdminAuth');
            const response = await axios.post('https://offers.cashbolt.in.net/server/', {
                action: 'addWhitelistedIP',
                authToken: token,
                ip: ipAddress
            });

            if (response.data.status) {
                setWhitelistedIPs(response.data.data.whitelistedIPs);
                setIpAddress('');
                alert('IP added to whitelist successfully!');
            } else {
                console.error('Failed to add IP:', response.data.message);
                alert('Failed to add IP: ' + response.data.message);
            }
        } catch (error) {
            console.error("Error adding IP:", error);
            alert('Error adding IP to whitelist');
        } finally {
            setIsAdding(false);
        }
    };

    const handleDeleteIP = async (id) => {


        setIsDeleting(true);
        try {
            const token = getCookie('offerAdminAuth');
            const response = await axios.post('https://offers.cashbolt.in.net/server/', {
                action: 'removeWhitelistedIP',
                authToken: token,
                ipId: id
            });

            if (response.data.status) {
                setWhitelistedIPs(response.data.data.whitelistedIPs);
                alert('IP removed from whitelist successfully!');
            } else {
                console.error('Failed to remove IP:', response.data.message);
                alert('Failed to remove IP: ' + response.data.message);
            }
        } catch (error) {
            console.error("Error removing IP:", error);
            alert('Error removing IP from whitelist');
        } finally {
            setIsDeleting(false);
        }
    };

    const toggleWhitelistStatus = async () => {
        const newStatus = !whitelistEnabled;
        try {
            const token = getCookie('offerAdminAuth');
            const response = await axios.post('https://offers.cashbolt.in.net/server/', {
                action: 'updateWhitelistStatus',
                authToken: token,
                status: newStatus
            });

            if (response.data.status) {
                setWhitelistEnabled(newStatus);
                //alert(`IP whitelist feature ${newStatus ? 'enabled' : 'disabled'} successfully!`);
            } else {
                console.error('Failed to update whitelist status:', response.data.message);
            }
        } catch (error) {
            console.error("Error updating whitelist status:", error);
           // alert('Error updating whitelist status');
        }
    };

    if (!authChecked || loading) {
        return (
            <div className="admin-loading">
                <div className="loading-spinner"></div>
            </div>
        );
    }
  const isValidIP = (ip) => {
    // Simple IP validation regex
    const ipRegex = /^(\d{1,3}\.){3}\d{1,3}$/;
    return ipRegex.test(ip);
  };

  return (
    <div className="admin-container">
      <Navbar />
      
      <header className="admin-header">
        <h1>IP Whitelist</h1>
      </header>

      <motion.div 
        className="settings-card"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
      >
        {/* Whitelist Toggle */}
        <div className="form-group">
          <label>IP Whitelisting</label>
          <div className="toggle-container">
            <button
              type="button"
              className={`toggle-option ${whitelistEnabled ? 'active' : ''}`}
              onClick={toggleWhitelistStatus}
            >
              <FiPower className="toggle-icon" /> 
              <span>On</span>
            </button>
            <button
              type="button"
              className={`toggle-option ${!whitelistEnabled ? 'active' : ''}`}
              onClick={toggleWhitelistStatus}
            >
              <FiPower className="toggle-icon" />
              <span>Off</span>
            </button>
          </div>
        </div>

        {/* Add IP Section */}
        <div className="form-group">
          <label>Add IP Address</label>
          <div className="input-with-button">
            <input
              type="text"
              value={ipAddress}
              onChange={(e) => setIpAddress(e.target.value)}
              placeholder="Enter IP address (e.g., 192.168.1.1)"
              className="ip-input"
            />
            <motion.button
              className="add-button"
              onClick={handleAddIP}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              disabled={!isValidIP(ipAddress)}
            >
              <FiPlus className="button-icon" />
              Add IP
            </motion.button>
          </div>
          {ipAddress && !isValidIP(ipAddress) && (
            <div className="error-message">Please enter a valid IP address</div>
          )}
        </div>

        {/* Whitelisted IPs Table */}
        <div className="whitelist-table-container">
          <table className="whitelist-table">
            <thead>
              <tr>
                <th>IP Address</th>
                <th>Added On</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {whitelistedIPs.map((ip) => (
                <motion.tr 
                  key={ip.id}
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 0.2 }}
                >
                  <td>{ip.ip}</td>
                  <td>{ip.createdAt}</td>
                  <td>
                    <button 
                      className="delete-button"
                      onClick={() => handleDeleteIP(ip.id)}
                    >
                      <FiTrash2 />
                    </button>
                  </td>
                </motion.tr>
              ))}
              {whitelistedIPs.length === 0 && (
                <tr>
                  <td colSpan="3" className="no-ips-message">
                    No IP addresses whitelisted yet
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </motion.div>
    </div>
  );
};

export default WhitelistIPPage;